module.exports = __webpack_public_path__ + "static/media/plan-oferta-wom-mas-gblibres-plus.932dc31e.svg";